import * as constants from "./constants";
import { sortCommodities } from "../../ActivityTypes/utils";

const initialState = {
  allCommodities: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const commodityReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_COMMODITIES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_COMMODITIES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allCommodities: sortCommodities([...state.allCommodities, action.data]),
        isAdding: false,
      };
    case constants.CREATE_COMMODITIES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.FETCH_COMMODITIES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_COMMODITIES_SUCCESS:

      return {
        ...state,
        fetchingLoading: false,
        allCommodities: sortCommodities(action.data),
        // totalRecords: total_departments,
        isAdding: false,
      };
    case constants.FETCH_COMMODITIES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_COMMODITIES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_COMMODITIES_SUCCESS:
      const updated = state.allCommodities.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allCommodities: sortCommodities(updated),
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_COMMODITIES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_COMMODITIES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_COMMODITIES_SUCCESS:
      const updatedData = state.allCommodities.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allCommodities: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_COMMODITIES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default commodityReducer;
